<template>
    <span class="markdown-span-override is-clearfix" :class="{hideElements}" v-html="body" @click="checkClick"></span>
</template>

<script>
import marked from '@/libs/marked'
import truncate from 'html-truncate'
import userAgent from '@/libs/user-agent'

export default {
  props: ['content', 'maxLength', 'isHeader', 'hideElements'],
  data: function () {
    return {
      body: ''
    }
  },
  mounted: function () {
    if (this.content && this.content.length > 0) {
      this.setBody(this.content)
    } else if (this.$slots && this.$slots.default && this.$slots.default.length > 0) {
      this.setBody(this.$slots.default[0].text)
    }
  },
  watch: {
    content: function (value) {
      this.setBody(value)
    }
  },
  methods: {
    setBody: function (body) {
      if (this.maxLength) {
        body = truncate(body, this.maxLength)
      }
      this.body = marked(body)
    },
    checkClick: function (event) {
      if (!userAgent.isApp()) {
        return
      }
      let link = null
      const target = event.target
      if (target && target.tagName.toLowerCase() === 'a') {
        link = target
      }
      if (!link && target) {
        const parent = target.parentNode
        if (parent && parent.tagName.toLowerCase() === 'a') {
          link = parent
        }
      }
      if (link) {
        window.open(link.href)
        event.preventDefault()
      }
    }
  }
}
</script>

<style lang="scss">
  .markdown-span-override {
    @import '~styles/markdown.scss';
    width:100%;
    pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    }
    a, p, h1, li, blockquote{
      background: transparent;
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
    }

    &.hideElements {
      em, img, iframe {
        display: none;

      }
      p:not(:empty) {
        padding-bottom: 1rem;
      }
    }
  }
</style>
